/* eslint-disable @typescript-eslint/naming-convention */
export enum ContentType {
  Accordion = 'accordion',
  ActionBanner = 'action_banner',
  AppFooterContent = 'app_footer_content',
  AppleTouchIcons = 'apple_touch_icons',
  Banner = 'banner',
  BonusGrid = 'bonus_grid',
  Box = 'box',
  BrandLogo = 'brand_logo',
  CTAGrid = 'cta_grid',
  Campaign = 'campaign',
  Carousel = 'carousel',
  CasinoCompletedRaces = 'casino_completed_races',
  CasinoGameDeck = 'casino_game_deck',
  CasinoGameGrid = 'casino_game_grid',
  CasinoGameInfo = 'casino_game_info',
  CasinoGameInfoDescription = 'casino_game_info_description',
  CasinoGameSlider = 'casino_game_slider',
  CasinoGameTrailer = 'casino_game_trailer',
  CasinoJackpot = 'casino_jackpot',
  CasinoMosaic = 'casino_mosaic',
  CasinoMyGames = 'casino_my_games',
  CasinoMyRewards = 'casino_my_rewards',
  CasinoNewGames = 'casino_new_games',
  CasinoPlayerGames = 'casino_player_games',
  CasinoRaces = 'casino_races',
  CasinoSearchParameters = 'casino_search_parameters',
  CasinoSecondaryNavigation = 'casino_secondary_navigation',
  CasinoTopGames = 'casino_top_games',
  CategoryHighlight = 'category_highlight',
  ContentArea = 'content_area',
  ContentCard = 'content_card',
  Crm = 'crm',
  DetailsGrid = 'details_grid',
  EntrySearchReference = 'entry_search_reference',
  EventSchedule = 'event_schedule',
  EventTournament = 'event_tournament',
  FAQ = 'faq',
  FirstWallet = 'first_wallet',
  Form = 'form',
  GeoRedirect = 'geo_redirect',
  Glossary = 'glossary',
  Grid = 'grid',
  HeaderLink = 'header_link',
  HelpBot = 'help_bot',
  HelpCenterArticle = 'help_center_article',
  HelpCenterCategory = 'help_center_category',
  HelpCenterHome = 'help_center_home',
  HelpCenterSearch = 'help_center_search',
  Highlight = 'highlight',
  IspConfig = 'isp_config',
  IconsGrid = 'icons_grid',
  LeaderBoard = 'leader_board',
  LegacySports = 'legacy_sports',
  LinkedImageList = 'linked_image_list',
  Language = 'language',
  Main = 'main',
  MatchInfo = 'match_info',
  MediaGrid = 'media_grid',
  Menu = 'menu',
  Meta = 'meta',
  Page = 'page',
  Panel = 'panel',
  PaymentVendors = 'payment_vendors',
  Podcast = 'podcast',
  PokerHomeGames = 'poker_home_games',
  PokerMultiTableTournaments = 'poker_multi_table_tournaments',
  PokerPowerPath = 'poker_power_path',
  PokerSpinAndGo = 'poker_spin_and_go',
  PokerStarsExchange = 'poker_stars_exchange',
  PokerStarsExchangeToggle = 'poker_stars_exchange_toggle',
  PokerSundayMillion = 'poker_sunday_million',
  PowerPathMoreTab = 'power_path_more_tab',
  PromotionBanner = 'promotion_banner',
  ProspectHomepageSlide = 'prospect_homepage_slide',
  Redirect = 'redirect',
  ReferAFriend = 'refer_a_friend',
  RegulatoryHeader = 'regulatory_header',
  ReusableContent = 'reusable_content',
  SEO = 'seo',
  SEOFooter = 'seo_footer',
  Side = 'side',
  SideCTA = 'side_cta',
  SideRelatedContent = 'side_related_content',
  SideTwitter = 'side_twitter',
  SiteFooter = 'site_footer',
  SiteHeader = 'site_header',
  StickyFooter = 'sticky_footer',
  Tabs = 'tabs',
  Template = 'template',
  Terms = 'terms',
  TilesGrid = 'tiles_grid',
  Top = 'top',
  UploadHistory = 'upload_history',
  VideoPanel = 'video_panel',
  Website = 'website',
  WebsiteConfig = 'website_config',
  WebsiteLanguages = 'website_languages'
}

export interface BasicReference {
  uid: string;
  _content_type_uid: string;
}

export interface Reference extends BasicReference {
  _content_type_uid: ContentType;
}
